export const MPI_ID_QUERY_PARAM = 'mpi-id';

/**
 * Tags a results link with the MPI id of the person being viewed.
 *
 * Every results target accepts the id as a query param, and the link shapes
 * differ — a tenant's custom link may already carry a query string while a
 * generated one always has `langCode` — so the separator is derived rather than
 * assumed. Without an id the link is returned untouched, which is the normal
 * case: the target then falls back to the signed-in user.
 */
export const withMpiId = (link: string, mpiId?: string | null): string => {
  if (!link || !mpiId) return link;

  const separator = link.includes('?') ? '&' : '?';
  return `${link}${separator}${MPI_ID_QUERY_PARAM}=${encodeURIComponent(mpiId)}`;
};

/** The `route` counterpart of {@link withMpiId} — routed links take params, not a string. */
export const mpiIdQueryParams = (mpiId?: string | null): Record<string, string> | undefined =>
  mpiId ? { [MPI_ID_QUERY_PARAM]: mpiId } : undefined;
